import { InputNumber as InputNumberArco } from "@arco-design/web-react";
import numeral from "numeral";
import { NUMERIC_INPUT_FORMAT } from "@/config";

const NumericInput = ({ value, precision, prefix, ...rest }) => {
    return (
        <InputNumberArco
            {...rest}
            prefix={prefix}
            precision={precision ?? 5}
            value={value}
            hideControl
            formatter={(val, { userTyping, input }) => {
                if (!val) return val;
                return userTyping ? input : numeral(val).format(NUMERIC_INPUT_FORMAT);
            }}
            parser={(value) => {
                if (!value) return value;
                return numeral(value).value();
            }}
            onChange={(val) => {
                let rawValue = val;
                if (rawValue) {
                    rawValue = numeral(rawValue).value();
                }
                rest.onChange && rest.onChange(rawValue);
            }}
        />
    );
};

export const InputNumber = (props) => <NumericInput {...props} />;

export const InputCurrency = (props) => <NumericInput prefix="$" {...props} />;

export const Number = ({ value, currency }) => {
    const formatted = numeral(value).format(NUMERIC_INPUT_FORMAT);
    return currency ? "$" + formatted : formatted;
}

export const Currency = (props) => {
    return <Number {...props} currency />;
}
